import { render, staticRenderFns } from "./taskTable.vue?vue&type=template&id=072f293d"
import script from "./taskTable.vue?vue&type=script&lang=js"
export * from "./taskTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports